// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8842cf4e","453":"d456ce70","455":"c81c1e89","977":"2e3d5464"}[chunkId] + ".chunk.js";
};